<script setup>
import { __, requestSelfcareAccountSubscriber, currentMonth } from '@/utils';
import { inject, ref, onMounted, computed } from 'vue';
import {
    Combobox,
    ComboboxInput,
    ComboboxOptions,
    ComboboxOption,
	ComboboxButton,
} from '@headlessui/vue';
import Loader from '@components/loader.vue';

import usageTables from '@components/usageTables/usageTables.vue';
import RangeSelect from '../components/range-select/range-select.vue';

const { details } = inject('account');

const searchParams = new URLSearchParams(window.location.search);
const subscribersArray = computed(() => details.value?.subscribers.filter(sub => sub.name !== currentSubscriber.value.name));
const subscriberID = searchParams.size > 0 ? details.value?.subscribers.find(sub => sub.name === searchParams.get('subscriber_id')) : details.value?.subscribers?.[0];

const currentSubscriber = ref(subscriberID);
const subscriberData = ref({});
const loader = ref(false);

const selectedDateRange = ref(currentMonth());

const services = ref(
    {
        call: { checked: true, title: __('Calls'), type: 'call' },
        sms: { checked: true, title: __('Messages'), type: 'sms'  },
        data: { checked: true, title: __('Browsing'), type: 'data'  }
    }
)


const getSubscriber = async (id) => {
    loader.value = true;
    let [data, error] = await requestSelfcareAccountSubscriber(id);
    loader.value = false;

    if (error) {
        console.error(error);
    } else if (data) {
        subscriberData.value = data.data;
    }
};

onMounted(() => {
    if (details.value?.subscribers?.[0]?.id) {
        getSubscriber(details.value?.subscribers?.[0]?.id);
    }
});
</script>
<template>
	<div class="account-main">
        <div class="invoice-header">
            <h4>{{ __('Details of my uses') }}</h4>
            <div class="invoice-header__content invoice-header__content-bottom-marging">
                <div class="cellular-phone-wrapper cellular-phone-wrapper--usages" v-if="details?.subscribers?.length">
                    <h5>{{ __('Select a subscription') }}</h5>
                    <div class="combobox-outer combobox-outer--fullbutton">
                        <Combobox v-model="currentSubscriber">
                            <div class="combobox-wrapper">
                                <ComboboxInput
                                    :displayValue="(value) => value.name" 
                                    id="subscription"
                                    name="subscription"
                                    disabled
                                />
                                <ComboboxButton class="combobox-icon" />
                            </div>
                            <ComboboxOptions class="combobox-options notice__options">
                                <ComboboxOption
                                    v-for="option in subscribersArray"
                                    :key="option.id"
                                    :value="option"
                                    class="combobox-option combobox-option--smaller"
                                >
                                    {{ option.name }}
                                </ComboboxOption>
                            </ComboboxOptions>
                        </Combobox>
                    </div>
                </div>
            </div>

            <div class="invoice-header__content invoice-header__content-bottom-marging">
                <div class="cellular-phone-wrapper cellular-phone-wrapper--usages">
                    <h5>{{ __('Select a test time range') }}</h5>
                    <RangeSelect
                        :subscriber="currentSubscriber"
                        @selectedDateRange="selectedDateRange = $event"
                    />
                </div>
            </div>
        </div>

        <div class="cellular-time-range invoice-header__content-bottom-marging">
            <h5>{{ __('Select the services you would like to view in detail') }}</h5>
            <div class="checkbox-outer">
                <div v-for="(service, key) in services" :key="key">
                    <label>
                        <input type="checkbox" v-model="service.checked"/>
                        <span></span>
                        {{ service.title }}
                    </label>
                </div>
            </div>
        </div>
        
        <Loader v-if="loader"  color="#2563eb" />
        <usageTables v-if="selectedDateRange"
            :displayedTables="services"
            :msisdn="currentSubscriber?.name"
            :selectedDate="selectedDateRange"
        />
    </div>
</template>